import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../api";
import { useAuth } from "../App";
import logoIcon from "../assets/Logo.png";

function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setIsError(false);
    setLoading(true);
    try {
      const response = await api.post("/api/login", formData);
      setMessage(response.data.message);
      setIsError(false);
      login(response.data.user);
      navigate("/dashboard");
    } catch (error) {
      setMessage(error.response?.data?.message || "Terjadi kesalahan saat login");
      setIsError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      {/* Left branding panel */}
      <div className="auth-left">
        <div className="auth-left-circle auth-left-circle-1" />
        <div className="auth-left-circle auth-left-circle-2" />

        <div className="auth-brand" style={{ position: "relative", zIndex: 1 }}>
          <div className="auth-brand-row">
            <img src={logoIcon} alt="AiDuNode" className="auth-brand-icon" />
            <span className="auth-brand-name">AiDuNode</span>
          </div>
          <h2 className="auth-left-title">
            Selamat Datang<br />Kembali! 👋
          </h2>
          <p className="auth-left-desc">
            Masuk ke akun AiDuNode kamu dan lanjutkan perjalanan belajar
            Arduino, ESP32, dan IoT bersama AI.
          </p>

          <div className="auth-left-chips">
            <span className="auth-left-chip">⚡ Kode Arduino</span>
            <span className="auth-left-chip">🔌 IoT &amp; ESP32</span>
            <span className="auth-left-chip">🤖 AI Spesialis</span>
            <span className="auth-left-chip">📋 17+ Template</span>
          </div>
        </div>

        <div className="auth-left-footer">
          © 2026 AiDuNode · Universitas Negeri Malang
        </div>
      </div>

      {/* Right form panel */}
      <div className="auth-right">
        <div className="auth-form-wrap">
          <div className="auth-form-header">
            <h1>Masuk ke Akun</h1>
            <p>Masukkan email dan password untuk melanjutkan.</p>
          </div>

          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="auth-input-group">
              <label className="auth-input-label">Email</label>
              <input
                className="auth-input"
                type="email"
                name="email"
                placeholder="nama@email.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="auth-input-group">
              <label className="auth-input-label">Password</label>
              <input
                className="auth-input"
                type="password"
                name="password"
                placeholder="••••••••"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>

            <div className="auth-forgot">
              <Link to="/forgot-password">Lupa password?</Link>
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-full btn-lg"
              disabled={loading}
            >
              {loading ? "⏳ Memproses..." : "Masuk →"}
            </button>
          </form>

          {message && (
            <div className={`auth-message ${isError ? "error" : "success"}`}>
              {isError ? "⚠️" : "✅"} {message}
            </div>
          )}

          <p className="auth-links">
            Belum punya akun?{" "}
            <Link to="/register">Daftar Gratis</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;